import { render, staticRenderFns } from "./BreadDirectoriosContent.vue?vue&type=template&id=44790edb&scoped=true&"
import script from "./BreadDirectoriosContent.vue?vue&type=script&lang=js&"
export * from "./BreadDirectoriosContent.vue?vue&type=script&lang=js&"
import style0 from "./BreadDirectoriosContent.vue?vue&type=style&index=0&id=44790edb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44790edb",
  null
  
)

export default component.exports